import { usePageStore } from '@/store';
export async function asyncData() {
    const pageStore = usePageStore(this.$pinia);
    return pageStore.getAgentInfo(this.agentId);
}
